function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.147,
    height: 17.147,
    viewBox: "0 0 17.147 17.147",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2950",
    d: "M-855.948-40.336h20.248",
    transform: "rotate(45 -477.663 1015.465)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3846",
    d: "M-855.948-40.336h20.248",
    transform: "rotate(45 -477.663 1015.467)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3847",
    d: "M-855.948-40.336h20.248",
    transform: "rotate(135 -428.754 161.07)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-close.fc4f8357943ef3743036532e84053e3f.svg";